//who we are page

//imports
import "./WohohiamePage.css";
import { NavLink } from "react-router-dom";

//main
export default function WohohiamePage() {
	//return
	return (
		<div>
			<div className="home-header-outer">
				<div className="home-header">
					<div className="home-title">Wohohiame</div>

					<div className="home-main-buttons">
						<a
							href="https://secure.qgiv.com/for/okbhopefoundation/"
							target="_blank"
							rel="noreferrer"
							className="home-donation-link"
						>
							<div className="home-donation button">Donate</div>
						</a>
						<div className="home-join">Join Our Team</div>
					</div>
				</div>
			</div>

			<div></div>
		</div>
	);
}
